export enum EditContentTemplatePages {
  DefaultSections = 0,
  DefaultContent = 1,
}
